import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { company, upcomingPages } from "../data/navigation";
export function Footer() {
  return <footer className="w-full bg-ink-deep text-white" data-id="element-10" data-mp="32nulgo2wc31d">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-12 md:px-8" data-id="element-11" data-mp="32pff8bhdzhy6">
        <div className="md:col-span-5" data-id="element-12" data-mp="36q93j5yqqyrl">
          <Logo data-id="element-13" data-mp="36n3cvmagrotr" />
          <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-white/65" data-id="element-14" data-mp="3ufa4y995p9nd">
            Plomberie, chauffage et installation sanitaire à Lyon et dans un rayon
            de 30 km. Artisans certifiés RGE depuis 2001.
          </p>
        </div>

        <nav aria-label="Pied de page" className="md:col-span-3" data-id="element-15" data-mp="3ldu3ir0bkhva">
          <h2 className="text-sm font-semibold text-white" data-id="element-16" data-mp="3qcnkwuiq8t0q">Navigation</h2>
          <ul className="mt-4 space-y-3 text-[15px]" data-id="element-17" data-mp="29z6uqczdolgf">
            <li data-id="element-18" data-mp="29xlzsm95j0i1">
              <Link to="/" className="text-white/65 hover:text-white" data-id="element-19" data-mp="2a19sxkaopkw8">
                Accueil
              </Link>
            </li>
            {upcomingPages.map(p => <li key={p.path} data-id="element-20" data-mp="3labqttpu02pb">
                <Link to={p.path} className="text-white/65 hover:text-white" data-id="element-21" data-mp="3lbdecxo1ahnx">
                  {p.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="md:col-span-4" data-id="element-22" data-mp="3v5n5kc18p9x2">
          <h2 className="text-sm font-semibold text-white" data-id="element-23" data-mp="3q83u1jvxfb8t">Coordonnées</h2>
          <ul className="mt-4 space-y-3 text-[15px] text-white/65" data-id="element-24" data-mp="3qaznow0qrdrg">
            <li data-id="element-25" data-mp="81flfk1o45ye">
              <a href={company.phoneHref} className="text-lime hover:underline" data-id="element-26" data-mp="80xmugrj9fnb">
                {company.phone}
              </a>
            </li>
            <li data-id="element-27" data-mp="ht3axfenzcx8">
              <a href={`mailto:${company.email}`} className="hover:text-white" data-id="element-28" data-mp="hrih5s06by0f">
                {company.email}
              </a>
            </li>
            <li data-id="element-29" data-mp="qthy6kb6v23d">{company.address}</li>
            <li data-id="element-30" data-mp="qujlbn5hbf1g">{company.hours}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10" data-id="element-31" data-mp="ms6hj4aalr7b">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-sm text-white/50 md:flex-row md:justify-between md:px-8" data-id="element-32" data-mp="mthlb43qmyyf">
          <p data-id="element-33" data-mp="yu7hkrnonpy7">© 2026 {company.name}. Tous droits réservés.</p>
          <p data-id="element-34" data-mp="yupiw2p7cucz">SIRET 123 456 789 00012 · Garantie décennale</p>
        </div>
      </div>
    </footer>;
}